import Tooltip from '@creditflowresearch/uilib/Tooltip';
import Region from '@/creditflowresearch/domain/Region';
import { useTableDictionaries } from '@/creditflowresearch/application/TableDictionaries';

interface IRegionCellProps {
  regionId: string,
  countryId: string,
  label?: string,
}

const RegionCell = ({ regionId, countryId, label = 'Issuer Country' }: IRegionCellProps) => {
  const { countries } = useTableDictionaries();
  const region = Region.from(regionId);
  const country = countries?.getById(countryId);

  if (!region) {
    return (<>-</>);
  }

  const tooltip = country ? `${ label }: ${ country.name }` : region.getName();

  return (
    <Tooltip placement="bottom" content={ tooltip }>
      { region.getAbbreviation() }
    </Tooltip>
  );
};

export default RegionCell;
